import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-607c2c4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-box",
  method: "dialog"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Souhaitez-vous dupliquer ce produit ?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "S’il en a, ses variants seront aussi dupliqués.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-red-600" }, [
  /*#__PURE__*/_createTextVNode("Par défaut, si aucun moyen d'expédition physique n'est "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" disponible pour le fournisseur, un e-billet sera automati-"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" quement sélectionné. Vous devrez ensuite le modifier manuellement après la duplication.")
], -1))
const _hoisted_6 = { class: "modal-action" }

import { ref, onMounted, toRef } from "vue";
import {PRODUCT_PROTOTYPES} from "@/constants/product/properties";
import {productService} from "@/_services/product/product";
import {IDupliacteMasterProduct} from "@/models/product/IMasterProduct";
import Swal from "@/_helpers/swal";


export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateProductModal',
  props: {
    productUuid: {
        type: String,
        required: true,
        default: "",
    },
    duplicateProductModalId: {
        type: String,
        required: true,
    },
},
  setup(__props) {

const props = __props;


const duplicateProductModalId = toRef(props, "duplicateProductModalId");
const modalHTMLElement = ref<HTMLDialogElement | null>(null);
const productUuid = toRef(props, "productUuid");

onMounted(() => {
    modalHTMLElement.value = document.querySelector(
        `#${duplicateProductModalId.value}`
    );
});

const closeModalDialog = () => {
    if (modalHTMLElement.value) {
        modalHTMLElement.value.close();
    }
};

const submitHandler = async (data) => {
    try {
        const params: IDupliacteMasterProduct = {
            uuid: productUuid.value,
            prototypeUuid: data.prototype
        }
        const res = await productService.duplicateMasterProduct(params);
        closeModalDialog();
        if (res) {
            Swal.info("Le produit a bien été dupliqué.");
        } else {
            Swal.error("Erreur lors de la duplication du produit");
        }

    } catch (err: any) {
        Swal.error("Erreur coté API");
    }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("dialog", {
    ref: "HTMLDialogElement",
    id: duplicateProductModalId.value,
    class: "modal modal-middle sm:modal-middle"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormKit, {
        type: "form",
        id: "duplicateProductForm",
        onSubmit: submitHandler,
        actions: false
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_FormKit, {
            type: "select",
            label: "Prototype associé au produit :",
            name: "prototype",
            options: [
                      { label: 'E-billet', value: _unref(PRODUCT_PROTOTYPES).TICKET},
                      { label: 'Physique', value: _unref(PRODUCT_PROTOTYPES).PHYSICAL },
                    ]
          }, null, 8, ["options"]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModalDialog()))
            }, "Annuler"),
            _createVNode(_component_FormKit, {
              type: "submit",
              label: "Dupliquer"
            })
          ])
        ]),
        _: 1
      })
    ])
  ], 8, _hoisted_1))
}
}

})